export default __webpack_public_path__ + "static/media/P-011.d2c1ff13.png";